import React, { useState, useMemo, Fragment } from 'react'
import { filter, includes, map, sum, get } from 'lodash'
import PropTypes from 'prop-types'

import Table from 'UI/Table'
import { objectToOptions } from "Utilities/selectOptions";
import { Filters, defaultFilters } from './Filters'
import { filteredCustomers, filteredVMs } from './Data'

const tableHeaders = headers => map(headers, ({ Header, accessor }) => ({
  Header,
  id: accessor,
  accessor: (data) => get(data[accessor], 'quantity') || 0,
  Cell: ({ value }) => value === 0 ? <div style={{ color: "#989898" }}>{value}</div> : value,
  Footer: ({ column, data }) => sum(map(data, column.id))
}))

const VmSplaReport = ({ spla, productTableHeaders, locations }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const currentTableHeaders = (filters.products == 'All' || filters.limitProductColumns) ? productTableHeaders : filter(
    productTableHeaders, header => includes(map(filters.products, 'value'), header.accessor)
  )

  const columns = [{ Header: 'Customer', accessor: 'customer_name', Footer: () => <strong>Totals: </strong> }, ...tableHeaders(currentTableHeaders)]

  const productOptions = useMemo(
    () => map(productTableHeaders, ({ Header: label, accessor: value }) => ({ label, value })),
    [productTableHeaders]
  )

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, customers: objectToOptions(spla, 'customer_id', 'customer_name'), locations, products: productOptions }} />

      <Table {...{
        data: filteredCustomers({ customers: spla, filters }),
        defaultSorted: [{ id: "customer_name", asc: true }],
        className: "-highlight",
        filterable: true,
        columns,
        SubComponent: (row) => (
          <Table {...{
            data: filteredVMs({ vms: row.original.vms, filters }),
            defaultSorted: [{ id: "vm_name", asc: true }],
            className: "-highlight",
            filterable: true,
            columns: [{ Header: 'Name', accessor: 'vm_name', Footer: () => <strong>Totals: </strong> }, ...tableHeaders(currentTableHeaders)],
          }} />
        )
      }} />
    </Fragment>
  )
}

VmSplaReport.propTypes = {

}

export default VmSplaReport
